import { checkDiff } from '../../utils/formValidation/errorCheckingFunctions';
import { getReqMessage } from '../../utils/formValidation/errorMessageFunctions';

export const validate = (typeId, initialEntry) => {
    let newErrors = {};

    if (!typeId) {
        newErrors = {
            ...newErrors,
            typeId: { error: true, message: getReqMessage('Document Type') }
        };
    } else newErrors = checkDiff(typeId, initialEntry);

    return newErrors;
};
